import styled from "styled-components";

export const StyledContainer = styled.div`
  width: 1400px;
  max-width: 100%;
  padding: 0 20px;
  margin: 50px auto 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  // border: 1px solid #fff;
`;
